module.exports = __webpack_public_path__ + "static/media/questionaireBg.f386d502.svg";